import { createContext, useContext } from 'react';

import { COMPACT_DENSITY, Density, REGULAR_DENSITY } from '@portal/common/models/density';
import { Size } from '@portal/common/utility/common-props-helpers';

import { QUERY_BUILDER_MODES, QueryBuilderMode } from '../../store/chat/types';

export type DataExplorerDensity = Density;

export type DataExplorerLayoutContextValueProps = {
    density: DataExplorerDensity;
    isCompact: boolean;
    isSplitMode: boolean;
    isQueryBuilderCollapsed: boolean;
    size?: Size;
};

export const getDataExplorerLayoutContextValue = (
    density: DataExplorerDensity,
    isSplitMode = false,
    isQueryBuilderCollapsed = false
): DataExplorerLayoutContextValueProps => ({
    density,
    isCompact: density === COMPACT_DENSITY,
    isSplitMode,
    isQueryBuilderCollapsed,
    size: density === COMPACT_DENSITY ? 'sm' : 'md',
});

export const DataExplorerLayoutContext = createContext<DataExplorerLayoutContextValueProps>(
    getDataExplorerLayoutContextValue(REGULAR_DENSITY)
);

export const useDataExplorerLayout = () => useContext(DataExplorerLayoutContext);

export type DataToolChartVisibilityContextValue = {
    areChartsVisible: boolean;
    toggleChartsVisibility: () => void;
};

export const DataToolChartVisibilityContext = createContext<DataToolChartVisibilityContextValue>({
    areChartsVisible: true,
    toggleChartsVisibility: () => undefined,
});

export const useDataToolChartVisibility = () => useContext(DataToolChartVisibilityContext);

export type QueryBuilderModeContextValue = {
    mode: QueryBuilderMode;
    setMode: (mode: QueryBuilderMode) => void;
};

export const QueryBuilderModeContext = createContext<QueryBuilderModeContextValue>({
    mode: QUERY_BUILDER_MODES.MANUAL,
    setMode: () => undefined,
});

export const useQueryBuilderMode = () => useContext(QueryBuilderModeContext);

export type QueryBuilderCollapseContextValue = {
    isCollapsed: boolean;
    isCollapseDisabled: boolean;
    setCollapsed: (isCollapsed: boolean) => void;
};

export const QueryBuilderCollapseContext = createContext<QueryBuilderCollapseContextValue>({
    isCollapsed: false,
    isCollapseDisabled: false,
    setCollapsed: () => undefined,
});

export const useQueryBuilderCollapse = () => useContext(QueryBuilderCollapseContext);
